if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

function filterVariantGroupedMedia(productInfo) {
  if (!productInfo) return;

  const mediaGallery = productInfo.querySelector('media-gallery');
  if (!mediaGallery) return;

  const selectedVariantInput =
    productInfo.querySelector('input[name="id"]') ||
    productInfo.querySelector('select[name="id"]');

  if (!selectedVariantInput || !selectedVariantInput.value) return;

  const selectedVariantId = String(selectedVariantInput.value);

  const viewerItems = Array.from(
    mediaGallery.querySelectorAll('.product__media-item[data-variant-ids]')
  ).filter(item => item.dataset.variantIds !== '');

  if (!viewerItems.length) return;

  const matchingViewerItems = viewerItems.filter((item) => {
    const variantIds = (item.dataset.variantIds || '')
      .split(',').map((v) => v.trim()).filter(Boolean);
    return variantIds.includes(selectedVariantId);
  });

  if (!matchingViewerItems.length) return;

  // Filtrează viewer items
  viewerItems.forEach((item) => {
    if (matchingViewerItems.includes(item)) {
      item.classList.remove('hide-image');
    } else {
      item.classList.add('hide-image');
      item.classList.remove('is-active');
    }
  });

  // Sincronizează thumbnailurile cu viewer items
  const matchingViewerIds = new Set(
    matchingViewerItems.map(item => item.dataset.mediaId)
  );

  const allThumbnails = Array.from(
    mediaGallery.querySelectorAll('.thumbnail-list__item[data-target]')
  );

  allThumbnails.forEach((item) => {
    if (matchingViewerIds.has(item.dataset.target)) {
      item.classList.remove('hide-image');
    } else {
      item.classList.add('hide-image');
      const button = item.querySelector('button.thumbnail');
      if (button) button.removeAttribute('aria-current');
    }
  });

  // Verifică is-active
  const currentActive = mediaGallery.querySelector('.product__media-item.is-active');
  const activeIsValid = currentActive && !currentActive.classList.contains('hide-image');

  if (!activeIsValid) {
    mediaGallery.querySelectorAll('.product__media-item').forEach(i => i.classList.remove('is-active'));
    const firstMatch = matchingViewerItems[0];
    if (firstMatch) {
      firstMatch.classList.add('is-active');
      firstMatch.classList.remove('hide-image');
      firstMatch.parentElement?.scrollTo({ left: firstMatch.offsetLeft });
    }
  }

  // Sync thumbnail aria-current
  const activeMediaId = mediaGallery.querySelector('.product__media-item.is-active')?.dataset.mediaId;

  allThumbnails.forEach((item) => {
    const button = item.querySelector('button.thumbnail');
    if (button) button.removeAttribute('aria-current');
  });

  const activeThumb = allThumbnails.find(
    item => item.dataset.target === activeMediaId && !item.classList.contains('hide-image')
  );

  if (activeThumb) {
    const button = activeThumb.querySelector('button.thumbnail');
    if (button) button.setAttribute('aria-current', 'true');
  }
}

function initVariantGroupedMedia() {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    if (productInfo.dataset.variantGroupingObserverAttached === 'true') return;
    productInfo.dataset.variantGroupingObserverAttached = 'true';

    const variantInput =
      productInfo.querySelector('input[name="id"]') ||
      productInfo.querySelector('select[name="id"]');

    if (!variantInput) return;

    let lastValue = null;

    function checkVariantChange() {
      const currentValue = variantInput.value;
      if (currentValue !== lastValue) {
        lastValue = currentValue;
        filterVariantGroupedMedia(productInfo);
      }
    }

    checkVariantChange();
    setTimeout(checkVariantChange, 100);
    setTimeout(checkVariantChange, 300);
    setTimeout(checkVariantChange, 600);

    productInfo.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => setTimeout(checkVariantChange, 50));
    });

    const interval = setInterval(checkVariantChange, 200);
    setTimeout(() => clearInterval(interval), 600000);
  });
}

document.addEventListener('DOMContentLoaded', initVariantGroupedMedia);
document.addEventListener('shopify:section:load', () => {
  initVariantGroupedMedia();
  setTimeout(initVariantGroupedMedia, 300);
});